import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22IBM_Plex_Sans_Arabic%22,%22arguments%22:[{%22weight%22:[%22700%22],%22subsets%22:[%22arabic%22],%22display%22:%22swap%22}],%22variableName%22:%22ibmArabic%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'IBM Plex Sans Arabic', 'IBM Plex Sans Arabic Fallback'",
        fontWeight: 700,
fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
